import { render } from "./UserSetting.vue?vue&type=template&id=fdfb6e34&scoped=true"
import script from "./UserSetting.vue?vue&type=script&lang=js"
export * from "./UserSetting.vue?vue&type=script&lang=js"

import "./UserSetting.vue?vue&type=style&index=0&id=fdfb6e34&lang=scss&scoped=true"
import "./UserSetting.vue?vue&type=style&index=1&id=fdfb6e34&lang=scss"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdfb6e34"]])

export default __exports__